import * as Yup from 'yup';

export const ValidationSchema = Yup.object({
    address: Yup.string().required('Required address'),
    lat: Yup.number().required('Latitude required'),
    long: Yup.number().required('Longitude required'),
    cluster: Yup.string().required('Cluster required'),
    envMonitoring: Yup.bool().required('Sensor required'),
    camera: Yup.bool().required('Camera required'),
})

export const ValidationSchemaGatway = Yup.object({
    gateway_id: Yup.string().required('Gateway id required'),
})

export const InitailValues = Yup.object({
    id: '',
    tag: '',
    address: '',
    alias: '',
    coordinates: {},
    cluster: '',
    connectivityType: '',
    envMonitoring: false,
    envMonitoringType: '',
    camera: false,
    cameraAddress: '',
    wifi: false,
    wifiAddress: '',
    description: '',
    peopleCounter: false,
})

